module.exports = __webpack_public_path__ + "static/media/环境减灾二号.4ccf9b3b.png";